import axios from 'axios'
import _ from 'lodash'
// import * as Sentry from '@sentry/node'

import { CREDITS_API_URL, getApiUrl } from '../../util/api/api'
import type { Entitlements } from '../../../state/reducers/entitlement/entitlement'

type FetchEntitlements = {
  data: Entitlements,
  status: number,
}

const fetchEntitlements = async (): Promise<FetchEntitlements> => {
  const credits = await axios.get(getApiUrl(CREDITS_API_URL))
  return credits
}

export default fetchEntitlements
